<div
  *ngIf="deviceType === 'desktop' || deviceType === 'tablet'"
  id="desktop-content"
>
  <div class="login-inside-container" id="div_login-inside-container_9a2a1a22">
    <h1 aria-label="WELCOME" title="WELCOME" id="h1_f9ca0180">WELCOME</h1>
    <form [formGroup]="frmLogin" id="form_586b57d2">
      <label id="label_4b7b32a0"
        >Enter your email address to get started.</label
      >
      <span class="p-float-label" id="span_p-float-label_16bce037">
        <input
          id="email"
          type="email"
          pInputText=""
          name="email"
          formControlName="email"
          aria-label="Email Input"
        />
        <label for="email" id="label_471a342d">Email</label>
      </span>
      <small
        class="p-error block"
        *ngIf="frmLogin.controls['email'].hasError('pattern')"
        aria-label="Please enter a valid email address."
        id="small_p-error_30b19696"
      >
        Please enter a valid email address.
      </small>
      <small
        class="p-error block"
        *ngIf="displayErrorAccountNotExists"
        aria-label="We couldn't find an account associated with this email. Not a problem, we've got you covered. Click the button below to join our waiting list."
        id="small_p-error_a6c81009"
      >
        We couldn't find an account associated with this email. Not a problem,
        we've got you covered. Click the button below to join our waiting list.
      </small>
      <div class="btn-panel" id="div_btn-panel_d8c468da">
        <button
          class="next-button"
          (click)="!displayErrorAccountNotExists ? checkEmail() : signUp()"
          [disabled]="!frmLogin?.get('email')?.valid"
          aria-label="NEXT Button"
          id="button_next-button_125c2224"
        >
          {{ !displayErrorAccountNotExists ? 'NEXT' : 'SIGN UP' }}
        </button>
      </div>
      <div class="bottom-pnl" id="div_bottom-pnl_9370383b">
        <p
          aria-label="If you believe this is an error, please reach out to your account manager or contact us for assistance."
          title="If you believe this is an error, please reach out to your account manager."
          *ngIf="displayErrorAccountNotExists"
          id="p_4212f1f7"
        >
          If you believe this is an error, please reach out to your account
          manager or
          <a
            aria-label="Contact Us"
            title="Contact Us"
            target="_blank"
            href="https://www.trinityrail.com/contact/"
            id="a_f1836da5"
          >
            contact us
          </a>
          for assistance.
        </p>
        <p
          aria-label="Don’t have an account? Contact your account manager or Request Access."
          title="Don’t have an account? Contact your account manager."
          *ngIf="!displayErrorAccountNotExists"
          id="p_87a74764"
        >
          Don’t have an account?
        </p>
        <p class="title-contact">
          Contact your account manager or
          <a
            aria-label="Contact Us"
            title="Contact Us"
            target="_blank"
            href="https://www.trinityrail.com/contact/"
            id="a_3018fcd3"
          >
            Request Access </a
          >.
        </p>
      </div>
    </form>
  </div>
</div>
<div
  class="progress-spinner"
  *ngIf="loading"
  id="div_progress-spinner_9f88c969"
>
  <p-progressSpinner
    styleClass="custom-spinner"
    aria-label="Loading Spinner"
    id="p-progressSpinner_1a45e809"
  ></p-progressSpinner>
</div>
<div *ngIf="deviceType === 'mobile'" id="mobile-sign">
  <div class="sign-in-mobile-2">
    <div class="div">
      <div class="login-modal">
        <div class="div-2">
          <img loading="lazy" src="assets/images/login-bg.webp" class="img" />
          <img loading="lazy" class="img-2" />
          <div class="delivering-goods-for-the-good-of-all™">
            DELIVERING GOODS FOR THE GOOD OF ALL™
          </div>
          <div class="div-3">
            <img loading="lazy" src="assets/logos/rsi_logo.png" class="img-3" />
            <div class="div-4">
              <div class="privacy-policy">
                <a
                  href="https://legal.trin.net/Home/Privacy"
                  target="_blank"
                  style="margin-right: 17px"
                  title="Privacy Policy"
                  aria-label="Privacy Policy, opens in a new window"
                  id="a_5eb3ff6d"
                  >Privacy Policy</a
                >
              </div>
              <div>
                <a
                  aria-label="Terms & Conditions"
                  title="Terms & Conditions"
                  href="https://legal.trin.net/"
                  target="_blank"
                  id="a_bca8a5cf"
                  >Terms & Conditions</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="div-5">
          <div class="welcome">Welcome</div>
          <div class="enter-your-email-address-to-get-started">
            Enter your email address to get started.
          </div>
        </div>
        <div class="div-6">
          <form [formGroup]="frmLogin" id="form_586b57d2">
            <span class="p-float-label" id="span_p-float-label_16bce037">
              <input
                id="email"
                type="email"
                pInputText=""
                name="email"
                formControlName="email"
                aria-label="Email Input"
              />
              <label for="email" id="label_471a342d">Email</label>
            </span>
            <small
              class="p-error block"
              *ngIf="frmLogin.controls['email'].hasError('pattern')"
              aria-label="Please enter a valid email address."
              id="small_p-error_30b19696"
            >
              Please enter a valid email address.
            </small>
            <small
              class="p-error block"
              *ngIf="displayErrorAccountNotExists"
              aria-label="We couldn't find an account associated with this email. Not a problem, we've got you covered. Click the button below to join our waiting list."
              id="small_p-error_a6c81009"
            >
              We couldn't find an account associated with this email. Not a
              problem, we've got you covered. Click the button below to join our
              waiting list.
            </small>
            <div class="btn-panel" id="div_btn-panel_d8c468da">
              <button
                class="next-button"
                (click)="
                  !displayErrorAccountNotExists ? checkEmail() : signUp()
                "
                [disabled]="!frmLogin?.get('email')?.valid"
                aria-label="NEXT Button"
                id="button_next-button_125c2224"
              >
                {{ !displayErrorAccountNotExists ? 'NEXT' : 'SIGN UP' }}
              </button>
            </div>
            <div class="bottom-pnl" id="div_bottom-pnl_9370383b">
              <p
                aria-label="If you believe this is an error, please reach out to your account manager or contact us for assistance."
                title="If you believe this is an error, please reach out to your account manager."
                *ngIf="displayErrorAccountNotExists"
                id="p_4212f1f7"
              >
                If you believe this is an error, please reach out to your
                account manager or
                <a
                  aria-label="Contact Us"
                  title="Contact Us"
                  target="_blank"
                  href="https://www.trinityrail.com/contact/"
                  id="a_f1836da5"
                >
                  contact us
                </a>
                for assistance.
              </p>
              <p
                aria-label="Don’t have an account? Contact your account manager or Request Access."
                title="Don’t have an account? Contact your account manager."
                *ngIf="!displayErrorAccountNotExists"
                id="p_87a74764"
              >
                Don’t have an account?
              </p>
              <p class="title-contact">
                Contact your account manager or
                <a
                  aria-label="Contact Us"
                  title="Contact Us"
                  target="_blank"
                  href="https://www.trinityrail.com/contact/"
                  id="a_3018fcd3"
                >
                  Request Access </a
                >.
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
